import { useState } from "react";
import TextHighlighter from "@/admin/atoms/TextHighlighter";
// import { KnowledgeBaseProp } from "src/services/dataTypeDefinition.type";
import { getViewArea } from "src/pages/api/user";
import KnowledgeBaseTab from "../KnowledgeBaseTab";
import { BtnVariant } from "../KnowledgeBaseTab/KnowledgeBaseTab";
import styles from "./KnowledgeBaseVideoLibrary.module.css";

// props: KnowledgeBaseProp
function KnowledgeBaseVideoLibrary(): JSX.Element {
  // const { searchTerm } = props;
  const searchTerm = "";
  const [btnList, setBntList] = useState<BtnVariant[]>([
    {
      title: "Add Videos",
      bntActive: true,
    },
    {
      title: "View all Videos",
      bntActive: false,
    },
    {
      title: "Add Video Category",
      bntActive: false,
    },
    {
      title: "View Video Category",
      bntActive: false,
    },
    {
      title: "Edit Category",
      bntActive: false,
    },
    {
      title: "Delete Category",
      bntActive: false,
    },
    {
      title: "Edit Video",
      bntActive: false,
    },
    {
      title: "Delete Video",
      bntActive: false,
    },
  ]);

  const switchState = (index2: number) => {
    setBntList(
      btnList.map((btnObject, index) => {
        if (index === index2) {
          return {
            title: btnObject.title,
            bntActive: true,
          };
        }
        return {
          title: btnObject.title,
          bntActive: false,
        };
      })
    );
  };

  return (
    <div className={styles.frame}>
      <div className="font-bold text-[24px] text-[#262626]">VIDEO LIBRARY</div>
      <div className=" text-[#434343]">
        <TextHighlighter
          searchValue={searchTerm}
          textContent="The Video Library feature contains such functionalities as adding
          videos, editing videos, deleting videos, creating video categories,
          editing video categories and deleting video categories."
          id="videoLibraryText1"
        />
      </div>

      <div className="w-full h-auto">
        <KnowledgeBaseTab
          btnList={btnList}
          callBack={switchState}
          getViewArea={getViewArea}
        />
      </div>
      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabAddVideos"
      >
        Add Videos
      </div>
      <img
        src="/images/knowledgebase-images/svgs/video-library/add-videos.svg"
        alt=""
        className="mt-10"
      />
      <div>
        <TextHighlighter
          searchValue={searchTerm}
          textContent='This is the default page that appears if no video has been added to your
        video library. To add a new video click on the 
        <span style="font-weight: bold;">“Add Video”</span> button'
          id="videoLibraryText2"
        />
      </div>
      <img
        src="/images/knowledgebase-images/svgs/video-library/add-video2.svg"
        alt=""
        className="mt-10"
      />
      <img
        src="/images/knowledgebase-images/svgs/video-library/add-video3.svg"
        alt=""
        className="mt-10"
      />

      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='In the <span style="font-weight: bold;">“Add Video”</span> page click on the
        <span style="font-weight: bold;">“Click to upload file”</span> and browse the
        video you wish to upload from your computer. Also, you will be required
        to add the details of the video e.g. the video title, description,
        author, cover image, tags and category to successfully upload your
        video. When this is done, click the 
        <span style="font-weight: bold;">“Save”</span> button at the bottom
        right-hand corner of the screen.'
          id="videoLibraryText3"
        />
      </div>
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent="In case you need to add multiple videos, you can click the 
        <span style='font-weight: bold';>“Save and add another”</span> button at the bottom right-hand
        corner of the screen to save the video you have already created but
        remain on the <span style='font-weight: bold;'>“Add Video”</span> screen to add another video."
          id="videoLibraryText4"
        />
      </div>
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent="Please note that the size of your uploaded video should not exceed 2GB
        and the size of the video`'`s cover image should not exceed 2MB."
          id="videoLibraryText5"
        />
      </div>

      <div className="font-bold mt-6">PLEASE NOTE:</div>
      <div>
        <TextHighlighter
          searchValue={searchTerm}
          textContent="<ul style='list-style-type: disc; padding-left: 40px;'>
                  <li>
                    You can add a video without adding a category to it. In a case where this happens, the video will be automatically classified as “Undefined” and will be moved to the “Undefined” category. 
                  </li>
                  <li>
                    Tenants who are operating a Trial account can only create a total of six videos and two categories. An upgrade to Premium will be required for full access. 
                  </li>
                </ul>"
          id="videoLibraryText7a"
        />
      </div>

      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabViewallVideos"
      >
        Videos upload
      </div>
      <img
        src="/images/knowledgebase-images/svgs/video-library/video-upload.svg"
        alt=""
        className="mt-10"
      />
      <div className="mt-10">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='When you click <span style="font-weight: bold;">"Save"</span> after uploading a video to the video library, an upload screen will appear. In a case where you wish to continue using the site while your video uploads, simply click <span style="font-weight: bold;">"Go to your Dashboard"</span>. You’ll be redirected back to the your dashboard screen where you can continue navigating the site while your video uploads in the background.

            This ensures you can save time and remain productive without waiting for the upload to be completed.'
          id="videoLibraryText6a"
        />
      </div>

      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabViewallVideos"
      >
        View All Videos
      </div>
      <img
        src="/images/knowledgebase-images/svgs/video-library/view-all-videos.svg"
        alt=""
        className="mt-10"
      />

      <div className="mt-10">
        <TextHighlighter
          searchValue={searchTerm}
          textContent=" To view all the videos in your video library, click on the <span style='font-weight: bold;'>“All Videos”</span>
          tab. This will display all the videos that have been added to your video
          library. If you want to add a new video from this screen, click on the 
          <span style='font-weight: bold;'>“Add New Video”</span> button at the top right-hand corner of the
          screen."
          id="videoLibraryText6"
        />
      </div>
      <div className="font-bold">PLEASE NOTE:</div>
      <div>
        {/* <ul >
          <li>
            You can also filter videos for your customized viewing by clicking
            the <span className="font-bold">“Filter”</span> button at the top
            right-hand corner of the screen
          </li>
          <li>
            For this version of
            <span className="text-[#EE2A7B]"> MyEdVault</span> you can only
            filter by video category. More filter option will be added in
            subsequent versions.
          </li>
        </ul> */}

        <TextHighlighter
          searchValue={searchTerm}
          textContent='<ul style="list-style-type: disc; padding-left: 40px;">
                  <li>
                    You can also filter videos for your customized viewing by clicking
                    the <span style="font-weight:bold;">“Filter”</span> button at the top
                    right-hand corner of the screen
                  </li>
                  <li>
                    For this version of 
                    <span style="color: #EE2A7B;">MyEdVault</span> you can only
                    filter by video category. More filter option will be added in
                    subsequent versions.
                  </li>
                </ul>'
          id="videoLibraryText7de"
        />
      </div>

      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabEditVideo"
      >
        Edit Video
      </div>
      <img
        src="/images/knowledgebase-images/svgs/video-library/edit-video.svg"
        alt=""
        className="mt-10"
      />

      <div>
        <TextHighlighter
          searchValue={searchTerm}
          textContent='To edit a video click on the edit icon next to the video in the 
        <span style="font-weight: bold;">“All Videos”</span> screen. Then edit the
        details of the video which you wish to edit and click 
        <span style="font-weight: bold;">“Save”</span>.'
          id="videoLibraryText15"
        />
      </div>
      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold  px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabDeleteVideo"
      >
        Delete Video
      </div>
      <img
        src="/images/knowledgebase-images/svgs/video-library/delete-video.svg"
        alt=""
        className="mt-10"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent="To delete a video click on the delete icon next to the video in the 
        <span style='font-weight: bold;'>“All Videos”</span> screen. You can also go to the video details
        page and click <span style='font-weight: bold;'>“Delete”</span> at the bottom left-hand corner of
        the screen."
          id="videoLibraryText16"
        />
      </div>
      <div className="font-bold mt-4">PLEASE NOTE:</div>
      <div>
        <ul>
          <li>
            <TextHighlighter
              searchValue={searchTerm}
              textContent="In a case where a video is deleted by mistake, you can reach out to
            our customer support handles via WhatsApp on +44 7404 036868 or via
            email at support@crestagile.com to have the video retrieved from our
            database."
              id="videoLibraryText17"
            />
          </li>
        </ul>
      </div>

      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabAddVideoCategory"
      >
        Add Video Category
      </div>
      <img
        src="/images/knowledgebase-images/svgs/video-library/add-video-category.svg"
        alt=""
        className="mt-10"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='To create a video category`&apos;` select the 
                <span style="font-weight: bold;">“Video category”</span> tab and click on the 
                <span style="font-weight: bold;">“Create Category”</span> button. Add your
                category name and click <span style="font-weight: bold;">“Save”</span>.'
          id="videoLibraryText8"
        />
      </div>
      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabViewVideoCategory"
      >
        View Video Category
      </div>
      <img
        src="/images/knowledgebase-images/svgs/video-library/view-video-category.svg"
        alt=""
        className="mt-10"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='If you have already created video categories, selecting the 
              <span style="font-weight: bold;">“Video Category”</span> tab will bring you
              to the screen with the list of all your video categories. To add a Video
              Category from this screen click on the 
              <span style="font-weight: bold;">“Create Category”</span> button at the top
              right-hand corner of the screen.
'
          id="videoLibraryText9"
        />
      </div>
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent=" Please note: You cannot add a video to a category that you have not
        initially created in the Categories section."
          id="videoLibraryText10"
        />
      </div>
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='In case you want to add a new category while adding a video click on the 
        <span style="font-weight: bold;">“Create New Category”</span> button in the
        Category section while adding a new video.'
          id="videoLibraryText11"
        />
      </div>
      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabEditCategory"
      >
        Edit Category
      </div>
      <img
        src="/images/knowledgebase-images/svgs/video-library/edit-category.svg"
        alt=""
        className="mt-10"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent=' To edit a Video Category click on the edit icon next to the Video
        category on the <span style="font-weight: bold;">“Video Category”</span> tab.
        Make your edit and click 
        <span style="font-weight: bold;">“Save Changes”</span>.'
          id="videoLibraryText12"
        />
      </div>
      <div
        className="w-full h-[48px] mt-10 flex items-center text-[#434343] font-bold px-5 rounded-lg bg-[#E5E7EB]"
        id="scrollTabDeleteCategory"
      >
        Delete Category
      </div>
      <img
        src="/images/knowledgebase-images/svgs/video-library/delete-category.svg"
        alt=""
        className="mt-10"
      />
      <div className="mt-4">
        <TextHighlighter
          searchValue={searchTerm}
          textContent='To delete a category click on the delete icon next to the Video Category
        in the <span style="font-weight: bold;">“Video Category”</span> tab.'
          id="videoLibraryText13"
        />
      </div>
      <div className="font-bold mt-4">PLEASE NOTE</div>
      <div>
        <TextHighlighter
          searchValue={searchTerm}
          textContent=" Deleting a Video Category automatically deletes the videos under that
        category. However, in case of future need of a video which was deleted
        as a result of deleting a video category, you can reach out to our
        customer support handles via WhatsApp on +44 7404 036868 or via email at
        support@crestagile.com to have the video retrieved from our database."
          id="videoLibraryText14"
        />
      </div>
    </div>
  );
}

export default KnowledgeBaseVideoLibrary;
